import { render, staticRenderFns } from "./SummarySendStudyModal.vue?vue&type=template&id=6f2f3f30&"
import script from "./SummarySendStudyModal.vue?vue&type=script&lang=js&"
export * from "./SummarySendStudyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports